module.exports = __webpack_public_path__ + "img/logo_small.60a7a53e.jpg";